import React, { useEffect, useState } from "react";

import { NavLink } from "react-router-dom";
import { useDeleteUserMutation, useGetUsersQuery } from "../../redux/userApi";
import { formatDateToDDMMYYYY } from "../Blogs/Blogs";
import { HiDotsVertical } from "react-icons/hi";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { ImBin } from "react-icons/im";
import { toast } from "react-toastify";
import { showConfirmDialog } from "../showConfirmDialog/ShowConfirmDialog";
import { truncateText } from "../Media/Media";
import { showErrorToast } from "../../utils/Utils";
import { useDebounce } from "use-debounce";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const AddUser = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < data?.totalPages) setPage((prev) => prev + 1);
  };

  const { data, error, isLoading, isFetching } = useGetUsersQuery({
    page,
    search: debouncedSearch,
  });
  const [deleteUser, { isLoading: isDeleteLoading }] = useDeleteUserMutation();
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      setTimeout(() => {
        if (
          !event.target.closest(".dropdown-container") &&
          openIndex !== null
        ) {
          setOpenIndex(null);
        }
      }, 1000);
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [openIndex]);
  const handleDeleteUser = async (id) => {
    try {
      const response = await deleteUser(id).unwrap();
      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      console.error("user error:", err);
      showErrorToast(err);
    }
  };

  const handleDeleteConfrim = (id) => {
    showConfirmDialog({
      title: "Delete User",
      message: "Are you sure you want to delete this User?",
      type: "danger",
      onConfirm: () => {
        handleDeleteUser(id);
      },
    });
  };

  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full overflow-hidden">
      <div className="flex justify-between items-center">
        <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
          Users
        </p>
        <div className="flex items-center">
          <NavLink
            to={"/users/create-user"}
            className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
          >
            + Add New User
          </NavLink>
        </div>
      </div>
      <div className=" flex flex-col gap-4 w-full">
        <div className=" flex justify-end w-full">
          <input
            type="search"
            placeholder="Search by name, email, or role..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            className="border-2 rounded-xl border-[#05004e40] md:p-3 p-2 outline-none md:w-[24rem] md:text-[1rem] text-[.8rem] w-[18rem]"
          />
        </div>
        {isLoading || isFetching ? (
          <div className=" flex flex-col gap-2">
            {loading.map((i) => (
              <div
                key={i}
                className="w-full flex items-center animate-pulse bg-[#EFEFEF] py-5 text-[1.2rem] rounded-2xl font-semibold capitalize"
              >
                <div className="bg-[#97979750] w-[15%] animate-pulse h-5 rounded-md mx-auto"></div>
                <div className="bg-[#97979750] w-[15%] animate-pulse h-5 rounded-md mx-auto"></div>
                <div className="bg-[#97979750] w-[15%] animate-pulse h-5 rounded-md mx-auto"></div>
                <div className="bg-[#97979750] w-[15%] animate-pulse h-5 rounded-md mx-auto"></div>
                <div className="bg-[#97979750] w-[15%] animate-pulse h-5 rounded-md mx-auto"></div>
              </div>
            ))}
          </div>
        ) : (
          data && (
            <>
              {data?.totalPages === 0 ? (
                <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
                  No User Found
                </div>
              ) : (
                <div className=" overflow-x-auto w-full pb-10">
                  <div className=" flex flex-col lg:gap-3 gap-2  min-w-[768px] mx-auto">
                    <div className="w-full flex items-center bg-[#DEE9E4] lg:py-5 py-3 lg:text-[1.2rem] md:text-[1rem] text-[.9rem] rounded-2xl font-semibold capitalize">
                      <div className="w-[20%] text-center  ">Image</div>
                      <div className=" w-[20%] text-center ">name</div>
                      <div className=" w-[20%] text-center ">role</div>
                      <div className=" w-[20%] text-center ">Date Created</div>
                      <div className=" w-[20%] text-center ">Actions</div>
                    </div>
                    {data?.users?.map((user, i) => (
                      <div
                        key={user?._id}
                        className="w-full flex items-center lg:text-[1rem] text-[.9rem]"
                      >
                        <div className="w-[20%] ">
                          <img
                            src={user?.profile}
                            className="lg:h-14 lg:w-14 h-12 w-12 rounded-full object-cover mx-auto"
                            alt=""
                          />
                        </div>
                        <div
                          title={user?.name}
                          className=" w-[20%] text-center font-medium "
                        >
                          {truncateText(user?.name, 20)}
                        </div>
                        <div className=" w-[20%] text-center capitalize ">
                          {user?.role}
                        </div>
                        <div className=" w-[20%] text-center ">
                          {formatDateToDDMMYYYY(user?.createdAt)}
                        </div>
                        <div className=" w-[20%] relative  ">
                          <HiDotsVertical
                            className=" w-full lg:size-7 size-5 text-center mx-auto dropdown-container cursor-pointer"
                            onMouseDown={() =>
                              setOpenIndex(openIndex === i ? null : i)
                            }
                          />
                          {openIndex === i && (
                            <div
                              className="absolute right-[52%] z-10 -mt-4 w-max origin-top-right rounded-md bg-[#fff] shadow-lg "
                              onClick={(e) => e.stopPropagation()}
                            >
                              <div className=" flex flex-col items-start gap-0.5 p-1 text-sm font-medium">
                                <NavLink
                                  to={`/users/update-user/${user?._id}`}
                                  className={`flex items-center gap-2 min-w-[6rem] border-b border-[#000] text-blue-500 hover:text-blue-800 `}
                                >
                                  <MdOutlineModeEditOutline /> Edit
                                </NavLink>

                                <button
                                  className={`flex items-center gap-2 min-w-[6rem] text-red-500 hover:text-red-800`}
                                  onClick={() => handleDeleteConfrim(user?._id)}
                                  disabled={isDeleteLoading ? true : false}
                                >
                                  <ImBin />
                                  Delete
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div className=" flex justify-between items-center">
                <div className=" text-[#0000004f]">
                  Showing record page {data?.currentPage} 0f {data?.totalPages}
                </div>
                <div className=" flex items-center gap-4">
                  <div
                    onClick={handlePrev}
                    disabled={page === 1}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === 1
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowBack className="size-6" />
                  </div>
                  {data?.currentPage}
                  <div
                    onClick={handleNext}
                    disabled={page === data?.totalPages}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === data?.totalPages
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowForward className="size-6" />
                  </div>
                </div>
              </div>
            </>
          )
        )}{" "}
      </div>
      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message}
        </p>
      )}
    </div>
  );
};

export default AddUser;
